module.exports = __webpack_public_path__ + "img/Выписка-из-реестра-лицензий-на-медицинскую-деятельность_Page_1.9be6ab5d.jpg";